/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Validation_Valid_Calendar_DateInputs */

const fr_validation_valid_calendar_date = /** @type {(inputs: Validation_Valid_Calendar_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saisissez une date calendaire valide.`)
};

const en_validation_valid_calendar_date = /** @type {(inputs: Validation_Valid_Calendar_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter a valid calendar date.`)
};

/**
* | output |
* | --- |
* | "Enter a valid calendar date." |
*
* @param {Validation_Valid_Calendar_DateInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const validation_valid_calendar_date = /** @type {((inputs?: Validation_Valid_Calendar_DateInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Validation_Valid_Calendar_DateInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_validation_valid_calendar_date(inputs)
	return fr_validation_valid_calendar_date(inputs)
});